/**
 * Skills on a parsed resume, in one shape regardless of how they were stored.
 *
 * Older resumes store a flat list; newer ones an object grouped by category.
 * Of 81 evaluated resumes, 51 used the grouped form, and the Resume tab —
 * which checked `skills.length` — showed no skills at all for any of them.
 *
 * Mirror of echohire-backend/src/utils/resumeSkills.js, which the PDF uses.
 */

const GROUPS = [
  ['technical',  'Technical'],
  ['frameworks', 'Frameworks'],
  ['tools',      'Tools'],
  ['cloud',      'Cloud'],
  ['soft',       'Soft skills'],
];

const clean = (list) => [...new Set(
  (Array.isArray(list) ? list : [])
    .map((s) => (typeof s === 'string' ? s.trim() : ''))
    .filter(Boolean)
)];

/** @returns {{label: string, items: string[]}[]} Empty groups omitted. */
export function groupedSkills(parsed = {}) {
  const raw = parsed?.skills;

  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    const groups = GROUPS
      .map(([key, label]) => ({ label, items: clean(raw[key]) }))
      .filter((g) => g.items.length);
    if (groups.length) return groups;
  }

  const flat = clean(Array.isArray(raw) ? raw : parsed?.skillsFlat);
  return flat.length ? [{ label: 'Skills', items: flat }] : [];
}
